
import { Language } from '@/context/LanguageContext';
import { generateSitemapEntries } from './sitemap/entryGenerator';
import { generateSitemapXML, generateSitemapIndex } from './sitemap/xmlGenerator';
import { calculateSitemapStats } from './sitemap/sitemapStats';

interface SitemapEntry {
  url: string;
  lastmod: string;
  changefreq: string;
  priority: string;
  language?: Language;
}

// Generate comprehensive sitemap entries for all pages
export const generateComprehensiveSitemap = async (baseUrl: string): Promise<SitemapEntry[]> => {
  return await generateSitemapEntries(baseUrl);
};

// Generate paginated sitemaps (max 50,000 URLs per sitemap as per Google guidelines)
export const generatePaginatedSitemaps = async (baseUrl: string, maxUrlsPerSitemap = 50000): Promise<string[]> => {
  const allEntries = await generateComprehensiveSitemap(baseUrl);
  const sitemaps: string[] = [];
  
  // Split entries into chunks
  for (let i = 0; i < allEntries.length; i += maxUrlsPerSitemap) {
    const chunk = allEntries.slice(i, i + maxUrlsPerSitemap);
    const sitemapXml = generateSitemapXML(chunk);
    sitemaps.push(sitemapXml);
  }
  
  return sitemaps;
};

// Export XML generation functions
export { generateSitemapIndex } from './sitemap/xmlGenerator';

// Get statistics about the sitemap
export const getSitemapStats = async () => {
  const entries = await generateComprehensiveSitemap('https://psychotherapist.help');
  return calculateSitemapStats(entries);
};
